import { CommonLibraryElementsStructuresCreator } from 'src/editor/shared/entities/common-library-elements-structures-creator'
import { PageLibraryElementsCreator } from './page-library-elements-creator'

// NOTE: This class is for non-website pages
export class PageLibraryElementsStructuresCreator extends CommonLibraryElementsStructuresCreator {
  constructor() {
    super(PageLibraryElementsCreator)
  }
}
